import BaseDialog from '@/components/BaseDialog';
import { Accordion, Span, Button, DataList, Text } from "@chakra-ui/react"
import React, { useState } from 'react';
import { IEmailAIExtractedData, IEmail, IApiLogs } from "../../../../types/common";
import { FaRegListAlt } from "react-icons/fa";
import { formatDateString } from '@/utils/date';
import { REVIEW_STATUS } from '@/constants/common';
import MainInformation from './MainInformation';
import Owners from './Owners';
import ProcessedFiles from './ProcessedFiles';

interface EmailAiExtractedDataDialogProps {
    emailAiExtractedData: IEmailAIExtractedData
}

const EmailAiExtractedDataDialog = ({
    emailAiExtractedData
}: EmailAiExtractedDataDialogProps) => {
    const [open, setOpen] = useState(false);

    const items = [
        { value: "a", title: "Main information", text: <MainInformation emailAiExtractedData={emailAiExtractedData}/>},
        { value: "b", title: "Owners", text:<Owners emailAiExtractedData={emailAiExtractedData} /> },
        { value: "c", title: "Processed files", text: <ProcessedFiles emailAiExtractedData={emailAiExtractedData}/> },
        { value: "d", title: "Notes", text: <Text>{emailAiExtractedData.notes?.trim() ? emailAiExtractedData.notes : "-"}</Text> },
        // { value: "e", title: "Raw ai response", text: "In progress..." },
    ];

    return (
        <BaseDialog
            trigger={<Button colorPalette='cyan'><FaRegListAlt /></Button>}
            title={'Email AI extracted data'}
            actionButtons={<Button variant='outline' onClick={() => setOpen(false)}>Close</Button>}
            open={open}
            setOpen={setOpen}
        >
            <Accordion.Root collapsible defaultValue={["a"]} variant="subtle">
                {items.map((item, index) => (
                    <Accordion.Item key={index} value={item.value}>
                        <Accordion.ItemTrigger css={{ cursor: "pointer"}}>
                            <Span flex="1">{item.title}</Span>
                            <Accordion.ItemIndicator />
                        </Accordion.ItemTrigger>
                        <Accordion.ItemContent>
                            <Accordion.ItemBody>{item.text}</Accordion.ItemBody>
                        </Accordion.ItemContent>
                    </Accordion.Item>
                ))}
            </Accordion.Root>
        </BaseDialog>
    )
}


export default EmailAiExtractedDataDialog;